import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import groups from './modules/groups'
import species from './modules/species'
import notification from './modules/notification'
import report from './modules/report'
import breeds from './modules/breeds'
import versionControl from './modules/version-control'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    groups,
    notification,
    report,
    species,
    versionControl,
    breeds,
  },
  state: {
    controls: {
      showDrawer: true,
    },
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    },
  },
})
